<script lang="ts" setup>
const isShow: Ref<boolean> = ref(false)

onMounted(() => {
  setTimeout(() => {
    isShow.value = true
  }, 100)
})
</script>

<template>
  <ul class="breadcrumb" :class="{ isShow: isShow }">
    <li>
      <div class="breadcrumb__item">首頁</div>
    </li>
    <li>
      <div class="breadcrumb__item isActive">zonezone 概念店</div>
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding-top: toRem(20);
  padding-bottom: toRem(20);
  transform: translateY(100%);

  @include max-height-media(950) {
    transform: translateY(50%);
  }

  @include max-height-media(720) {
    transform: translateY(0%);
  }

  @include max-media(767) {
    transform: translateY(0%);
  }

  li {
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.8s ease-in-out;
  }

  &.isShow {
    li {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @include max-media(480) {
    justify-content: center;
  }

  &__item {
    font-size: toRem(14);
    color: $color-gray-3;

    &.isActive {
      color: $color-white-1;
    }

    &:not(.isActive) {
      position: relative;
      padding-right: toRem(30);

      &::after {
        content: '';
        position: absolute;
        right: toRem(13);
        top: 50%;
        margin-top: toRem(-2);
        width: toRem(4);
        height: toRem(4);
        background-color: $color-gray-3;
      }
    }
  }
}
</style>
